import { AllMallData } from "./FunctionRun/MallData";
import { MapData, user } from "./userData";

export async function localSocket(name, data, cb) {
  if (name === "connectWithMall") {


    let id = 1
    user[id] = new MapData(id, data.mallId)
    // console.log(name ,data ,user[id],"connectWithMall3311");
    let datas = await user[id].receveDataPoint()
    // console.log(datas,"1133");
    // cb(user[id].receveDataPoint())
    cb(datas)
  }
  if (name == "findpath") {
    let id = 1
    if (user[id]) {
      let findData = user[id].findPath(data.raw.start, data.raw.end, data.raw.stape)
      // path = findData  
      // console.log(findData, "yeeeeeeeeeeeee");
      if (findData?.path?.length > 0) {
        cb(findData)
      }
      // io.sockets.emit(`findpath${data.id}`, findData)
    } else {
      console.log("user not create");
    }
  }
  if (name === "endpointsendAndReceive") {
    let id = 1
    if (user[id]) {
      if (AllMallData[user[id].mallid]) {
        let selectEndPoint = AllMallData[user[id].mallid].nodePoint[`${data.data}`]
        cb(selectEndPoint)
        //   io.sockets.emit(`endpointrecive${data.id}`, selectEndPoint)  // bheja 
      } else {
        console.log("AllMallData is not Load");
      }
    } else {
      console.log("user is not creating when endpoint selecting ");
    }
  }
  if (name == "killpath") {
    cb("kill");
  }
  if (name == "floor") {

  }
  if (name == "nextandpre") {
    cb(data.data)
  }
}
// export async function localSocket(name, data, cb) {
//   const myWorker = new Worker('./socketWorker.js', );
//   myWorker.onmessage = function(e) {
//     console.log(" yee ho raha ahi ");
//     cb(e.data)
//   };
//   myWorker.postMessage({name,data});
// }






